import styled from "styled-components";

export const Container = styled.div`
    background-color: #f5f5f5;
    padding: 2rem 10rem;
`;
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4rem;
    background-color: #FFFFFF;
    border-radius: 1.5rem;

    >h2 {
        font-size: 2rem;
        font-weight: 700;
        color: #606060;
    }

    > p{
        font-size: 1rem;
        font-weight: 400;
        margin-top: 1em;
        color: #606060;
    }
`;

export const ButtonsContainer = styled.div`
    
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    margin-top: 5rem;

    > button {
        min-width: 30%; 
        border-radius: 2rem;
        font-size: 1rem;
        padding: 0.75em 0;
    }

    >#first-btn {
        display: none;
    }

    >#back-btn {
        color: #B6B6B6;
        border: 2px solid #B6B6B6;
        font-weight: 600;
    }

    >#forward-btn {
        background-color: #6EA6FF;
        font-weight: 700;
        color: #FFF;
        > span {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    >#last-btn {
        background-color: #23C820;
        font-weight: 700;
        color: #FFF;
    }
`;
